import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrendingHotels } from '../components/TrendingHotels';
import { TrendingDestinations } from '../components/TrendingDestinations';
import { ReviewsSection } from '../components/ReviewsSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white" data-id="element-593">
      <Header data-id="element-594" />
      <main data-id="element-595">
        <HeroSection data-id="element-596" />
        <TrendingHotels data-id="element-597" />
        <TrendingDestinations data-id="element-598" />
        <ReviewsSection data-id="element-599" />

        <section className="py-16 bg-gray-50 border-t border-gray-200" data-id="element-600">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-601">
            <div className="space-y-8" data-id="element-602">
              <div data-id="element-603">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-604">
                  Luxury Hotels
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-605">
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-606">
                    The Gateway Resort Damdama Lake Gurgaon
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-607">
                    The Westin Kolkata Rajarhat
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-608">
                    Taj Connemara Chennai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-609">
                    Andaz Delhi A Concept By Hyatt
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-610">
                    Samode Palace Jaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-611">
                    Wildflower Hall Shimla
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-612">
                    The Leela Palace Chennai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-613">
                    The Oberoi Cecil Shimla
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-614">
                    Taj Chia Kutir Resort & Spa Darjeeling
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-615">
                    Itc Royal Bengal Kolkata
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-616">
                    Novotel Bengaluru Outer Ring Road
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-617">
                    Radisson Blu Resort Visakhapatnam
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-618">
                    Radisson Resort & Spa Lonavala
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-619">
                    Rokeby Manor Landour Mussoorie
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-620">
                    The Malabar Ramali
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-621">
                    The Terraces Kanatal
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-622">
                    Vivanta Dal View Srinagar
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-623">
                    Intercontinental Chennai Mahabalipuram Resort
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-624">
                    Taj Exotica Resort & Spa Goa
                  </a>
                </p>
              </div>

              <div data-id="element-625">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-626">
                  5 Star Hotels
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-627">
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-628">
                    5 Star Hotels in Kerala
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-629">
                    5 Star Hotels in West Bengal
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-630">
                    5 Star Hotels in Uttar Pradesh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-631">
                    5 Star Hotels in Uttarakhand
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-632">
                    5 Star Hotels in Tripura
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-633">
                    5 Star Hotels in Tamil Nadu
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-634">
                    5 Star Hotels in Telangana
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-635">
                    5 Star Hotels in Punjab
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-636">
                    5 Star Hotels in Nagaland
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-637">
                    5 Star Hotels in Madhya Pradesh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-638">
                    5 Star Hotels in Maharashtra
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-639">
                    5 Star Hotels in Meghalaya
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-640">
                    5 Star Hotels in Ladakh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-641">
                    5 Star Hotels in Karnataka
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-642">
                    5 Star Hotels in Gujarat
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-643">
                    5 Star Hotels in Arunachal Pradesh
                  </a>
                </p>
              </div>

              <div data-id="element-644">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-645">
                  4 Star Hotels
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-646">
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-647">
                    4 Star Hotels in Delhi
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-648">
                    4 Star Hotels in Mumbai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-649">
                    4 Star Hotels in Bangalore
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-650">
                    4 Star Hotels in Goa
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-651">
                    4 Star Hotels in Jaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-652">
                    4 Star Hotels in Hyderabad
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-653">
                    4 Star Hotels in Chennai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-654">
                    4 Star Hotels in Kolkata
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-655">
                    4 Star Hotels in Pune
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-656">
                    4 Star Hotels in Ahmedabad
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-657">
                    4 Star Hotels in Udaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-658">
                    4 Star Hotels in Agra
                  </a>
                </p>
              </div>

              <div data-id="element-659">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-660">
                  Boutique Hotels
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-661">
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-662">
                    Boutique Hotels in Jaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-663">
                    Boutique Hotels in Udaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-664">
                    Boutique Hotels in Goa
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-665">
                    Boutique Hotels in Rishikesh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-666">
                    Boutique Hotels in Shimla
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-667">
                    Boutique Hotels in Mussoorie
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-668">
                    Boutique Hotels in Jodhpur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-669">
                    Boutique Hotels in Pushkar
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-670">
                    Boutique Hotels in Manali
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-671">
                    Boutique Hotels in Darjeeling
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-672">
                    Boutique Hotels in Pondicherry
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-673">
                    Boutique Hotels in Coorg
                  </a>
                </p>
              </div>

              <div data-id="element-674">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-675">
                  Luxury Resorts
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-676">
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-677">
                    The Leela Ambience Gurgaon
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-678">
                    Trivik Hotels & Resorts Chikmagalur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-679">
                    Brijrama Palace Varanasi
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-680">
                    Taj Mahal New Delhi
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-681">
                    Java Rain Resort Chikmagalur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-682">
                    Oakwood Premier Prestige Bangalore
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-683">
                    Polo Orchid Resort Cherrapunjee
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-684">
                    Shiv Vilas Resorts Jaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-685">
                    The Elgin Darjeeling
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-686">
                    The Residency Towers Puducherry
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-687">
                    Trident Nariman Point Mumbai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-688">
                    Fort Rajwada Jaisalmer
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-689">
                    Oberoi Rajvilas Jaipur
                  </a>
                </p>
              </div>

              <div data-id="element-690">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-691">
                  3 Star Hotels
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-692">
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-693">
                    3 Star Hotels in Delhi
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-694">
                    3 Star Hotels in Mumbai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-695">
                    3 Star Hotels in Bangalore
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-696">
                    3 Star Hotels in Goa
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-697">
                    3 Star Hotels in Jaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-698">
                    3 Star Hotels in Hyderabad
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-699">
                    3 Star Hotels in Chennai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-700">
                    3 Star Hotels in Kolkata
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-701">
                    3 Star Hotels in Pune
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-702">
                    3 Star Hotels in Shimla
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-703">
                    3 Star Hotels in Manali
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-704">
                    3 Star Hotels in Ooty
                  </a>
                </p>
              </div>

              <div data-id="element-705">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-706">
                  Budget Hotels
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-707">
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-708">
                    Budget Hotels In Goa
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-709">
                    Budget Hotels In Jaipur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-710">
                    Budget Hotels In Ooty
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-711">
                    Budget Hotels in Kerala
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-712">
                    Budget Hotels in West Bengal
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-713">
                    Budget Hotels in Uttar Pradesh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-714">
                    Budget Hotels in Uttarakhand
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-715">
                    Budget Hotels in Tripura
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-716">
                    Budget Hotels in Tamil Nadu
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-717">
                    Budget Hotels in Telangana
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-718">
                    Budget Hotels in Punjab
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-719">
                    Budget Hotels in Nagaland
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-720">
                    Budget Hotels in Madhya Pradesh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-721">
                    Budget Hotels in Maharashtra
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-722">
                    Budget Hotels in Meghalaya
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-723">
                    Budget Hotels in Ladakh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-724">
                    Budget Hotels in Karnataka
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-725">
                    Budget Hotels in Gujarat
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-726">
                    Budget Hotels in Arunachal Pradesh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-727">
                    Budget Hotels In Mysore
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-728">
                    Budget Hotels In Pondicherry
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-729">
                    Budget Hotels In Manali
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-730">
                    Budget Hotels In Mumbai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-731">
                    Budget Hotels In Chennai
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-732">
                    Budget Hotels In Chandigarh
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-733">
                    Budget Hotels In Pune
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-734">
                    Budget Hotels In Agra
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-735">
                    Budget Hotels In Ahmedabad
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-736">
                    Budget Hotels In Gangtok
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-737">
                    Budget Hotels In Coimbatore
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-738">
                    Budget Hotels In Dharamshala
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-739">
                    Budget Hotels In Jaisalmer
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-740">
                    Budget Hotels In Jodhpur
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-741">
                    Budget Hotels In Mangalore
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-742">
                    Budget Hotels In Matheran
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-743">
                    Budget Hotels In Munnar
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-744">
                    Budget Hotels In Mussoorie
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-745">
                    Budget Hotels In Gurgaon
                  </a>{' '}
                  |{' '}
                  <a href="#" className="hover:text-travel-blue-600 transition-colors" data-id="element-746">
                    Budget Hotels In Shimla
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-747" />
    </div>;
}